/* eslint-disable @typescript-eslint/no-explicit-any */
import type Highcharts from "highcharts";
import "highcharts/es-modules/Core/Axis/OrdinalAxis";
import "highcharts/es-modules/Core/Axis/BrokenAxis";

// repro: watch the diagnosis page of a smoke integration project while test is running, this.ordinal is undefined and function crashes
export default function fixAxisVal2lin(H: typeof Highcharts) {
  H.wrap(
    H.Axis.prototype,
    "val2lin",
    function (this: Highcharts.Axis, proceed: any, ...args: unknown[]) {
      // @ts-expect-error
      if (this.ordinal === undefined) return args[0];
      return proceed.apply(this, args);
    },
  );
}
